<template>
  <span :class="badgeClass">{{ textStatus }}<span v-if="foc && status == 'porting'"> (FOC: {{ foc }})</span></span>
</template>
<script>
import moment from 'moment'

export default {
  name: 'NumberStatus',
  props: [ 'status', 'focDate' ],
  computed: {
    foc: function () {
      if (this.focDate) {
        return moment(this.focDate).format('MM/DD/YYYY')
      } else {
        return null
      }
    },
    textStatus: function () {
      if (this.status == 'porting') {
        return 'Porting'
      } else if (this.status == 'active') {
        return 'Active'
      } else {
        return 'Unknown'
      }
    },
    badgeClass: function () {
      if (this.status == 'porting') {
        return 'badge badge-warning'
      } else if (this.status == 'active') {
        return 'badge badge-success'
      } else {
        return 'badge badge-danger'
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped></style>
